import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, ExternalLink, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

export default function CenterDetail() {
  const { id } = useParams();
  const [center, setCenter] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/centers/${id}`).then((r) => setCenter(r.data.center)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="max-w-4xl mx-auto px-6 py-24 text-center">
        <h1 className="font-heading text-3xl text-primary-blue">Centre introuvable</h1>
        <Link to="/centres"><Button className="mt-6 bg-primary-blue text-white">Retour à l'annuaire</Button></Link>
      </div>
    );
  }
  if (!center) return <div className="p-10 text-slate-500">Chargement…</div>;

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-14">
      <Link to="/centres" className="text-primary-blue text-sm inline-flex items-center gap-1 hover:underline">
        <ArrowLeft size={16} /> Retour à l'annuaire
      </Link>

      <div className="mt-6 bg-white p-8 md:p-12 rounded-2xl border border-slate-100 card-lux">
        <Badge className="bg-sky-blue text-primary-blue border border-primary-blue/20">{center.network_slug}</Badge>
        <h1 className="font-heading text-3xl md:text-4xl text-primary-blue mt-4" data-testid="center-name">{center.name}</h1>
        <div className="mt-6 grid md:grid-cols-2 gap-6 text-slate-700">
          <div className="flex items-start gap-3"><MapPin size={20} className="text-primary-blue mt-0.5" /><div>{center.address}<br />{center.postal_code} {center.city}</div></div>
          {center.phone && <div className="flex items-center gap-3"><Phone size={20} className="text-primary-blue" />{center.phone}</div>}
          {center.email && <div className="flex items-center gap-3"><Mail size={20} className="text-primary-blue" />{center.email}</div>}
          {center.hours && <div className="flex items-center gap-3"><Clock size={20} className="text-primary-blue" />{center.hours}</div>}
          {center.website && (
            <a href={center.website} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-primary-blue hover:underline">
              <ExternalLink size={20} /> Site officiel
            </a>
          )}
        </div>

        {center.services?.length > 0 && (
          <div className="mt-8">
            <div className="font-heading text-xl text-primary-blue">Services proposés</div>
            <div className="mt-3 flex flex-wrap gap-2">
              {center.services.map((s) => (
                <Badge key={s} variant="outline" className="border-primary-blue/30 text-primary-blue">{s}</Badge>
              ))}
            </div>
          </div>
        )}

        <div className="mt-10 pt-6 border-t border-slate-200 flex flex-wrap gap-3">
          <Link to={`/prendre-rendez-vous?network=${center.network_slug}&center=${center.id}`}>
            <Button className="btn-lg-senior bg-primary-blue text-white hover:bg-[#0a1d36]">
              Prendre rendez-vous <span className="ml-2 text-gold font-bold">GRATUIT</span>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
